




import { defineComponent } from '@nuxtjs/composition-api'
import ProductList from '@/components/feature/PDP/ProductList.vue'
import { PDPTemplateComponent } from '~/modules/contentstack/pdpTemplateParser'

export default defineComponent({
  components: { ProductList },
  props: {
    templateComponentData: {
      type: Object as () => PDPTemplateComponent,
      required: true,
    },
  },
})
